import Api_Mec from "./Api_Mec";

class MEC_Momentos_api extends Api_Mec {
    constructor() {
        super();
    }

    insert(prmForm){
        return this.post(this.url_api+'/MEC_API/MEC_Momentos/insert', prmForm, {});
    }
    delete_id(prmCriterio){
        return this.post(this.url_api+'/MEC_API/MEC_Momentos/delete_id', {'id_plantilla': prmCriterio}, {});
    }
    getIdPlantilla(prmCriterio){
        return this.post(this.url_api+'/MEC_API/MEC_Momentos/getIdPlantilla', {"id_plantilla": prmCriterio }, {});
    }
}
export default MEC_Momentos_api